// YYYY-MM-DD for a Date as the USER sees it (local calendar day).
//
// Date.prototype.toISOString() is always UTC, which is the previous calendar
// day for anyone in IST between 00:00 and 05:30 — so a date picker defaulting to
// "today" via toISOString() silently pointed at yesterday during that window.
export const toLocalDateString = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const todayLocal = (): string => toLocalDateString(new Date());
